import { lazy, Suspense } from "react";

import HdLoader from "@hd/ui-kit/hd-loader/HdLoader";
import HdModal from "@hd/ui-kit/hd-modal/HdModal";

import { useCreditCardModalStore } from "./credit-card-modal.store";

const CreditCardModalContent = lazy(() => import("./CreditCardModalContent"));

function CreditCardModal() {
  const isOpen = useCreditCardModalStore((state) => state.isOpen);
  const closeModal = useCreditCardModalStore((state) => state.close);

  return (
    <HdModal
      backdrop={true}
      isOpen={isOpen}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeModal();
        }
      }}
      // closeOnClickOutside={false}
      className="p-2 bg-white w-[500px] h-[380px] flex flex-col"
    >
      <Suspense fallback={<HdLoader></HdLoader>}>
        <CreditCardModalContent></CreditCardModalContent>
      </Suspense>
    </HdModal>
  );
}

export default CreditCardModal;
